import { firstJuly2025ArticleCard } from 'constants/articles/first-july-2025-article';
import { secondJuly2025ArticleCard } from 'constants/articles/second-july-2025-article';
import { forthJuly2025ArticleCard } from 'constants/articles/forth-july-2025-article';
import { firstAugust2025ArticleCard } from 'constants/articles/first-august-2025-article';
import { secondAugust2025ArticleCard } from 'constants/articles/second-august-2025-article';
import { thirdAugust2025ArticleCard } from 'constants/articles/third-august-2025-article';
import { forthAugust2025ArticleCard } from 'constants/articles/forth-august-2025-article';
import { firstSeptember2025ArticleCard } from 'constants/articles/first-september-2025-article';
import { secondSeptember2025ArticleCard } from 'constants/articles/second-september-2025-article';
import { thirdSeptember2025ArticleCard } from 'constants/articles/third-september-2025-article';
import { waveSensePartnershipCard } from 'constants/partnership/wave-sense';
import { amdSiloPartnershipCard } from 'constants/partnership/amd-silo';

import { TCardProps } from 'types/common';

import ThirdCardImage from 'assets/resources/third-card.webp';
import FirstLinkedInPostImage from 'assets/linked-in-posts/first-linkedin-post.webp';
import SecondLinkedInPostImage from 'assets/linked-in-posts/second-linked-in-post.webp';
import ThirdLinkedInPostImage from 'assets/linked-in-posts/third-linked-in-post.webp';
import ForthLinkedInPostImage from 'assets/linked-in-posts/forth-linked-in-post.webp';
import FifthLinkedInPostImage from 'assets/linked-in-posts/fifth-linked-in-post.webp';
import SixthLinkedInPostImage from 'assets/linked-in-posts/six-linked-in-post.webp';
import { forthSeptember2025ArticleCard } from 'constants/articles/forth-september-2025-article';
import { thirdJuly2025ArticleCard } from 'constants/articles/third-july-2025-article';
import { firstSeptember2025NewsCard } from 'constants/news/first-september-2025-news';
import { fifthSeptember2025ArticleCard } from 'constants/articles/fifth-september-2025-article';
import { firstOctober2025ArticleCard } from 'constants/articles/first-october-2025-article';
import { secondOctober2025ArticleCard } from 'constants/articles/second-october-2025-article';
import { thirdOctober2025ArticleCard } from 'constants/articles/third-october-2025-article';
import { forthOctober2025ArticleCard } from 'constants/articles/forth-october-2025-article';

export const CARDS: TCardProps[] = [
  firstJuly2025ArticleCard,
  secondJuly2025ArticleCard,
  thirdJuly2025ArticleCard,
  forthJuly2025ArticleCard,
  firstAugust2025ArticleCard,
  secondAugust2025ArticleCard,
  thirdAugust2025ArticleCard,
  forthAugust2025ArticleCard,
  firstSeptember2025ArticleCard,
  secondSeptember2025ArticleCard,
  fifthSeptember2025ArticleCard,
  thirdSeptember2025ArticleCard,
  waveSensePartnershipCard,
  amdSiloPartnershipCard,
  forthSeptember2025ArticleCard,
  firstSeptember2025NewsCard,
  firstOctober2025ArticleCard,
  secondOctober2025ArticleCard,
  thirdOctober2025ArticleCard,
  forthOctober2025ArticleCard,
];

interface LinkedInPost {
  imageSrc: string;
  postUrl: string;
}

export const LINKED_IN_POSTS: LinkedInPost[] = [
  {
    imageSrc: FirstLinkedInPostImage,
    postUrl:
      'https://www.linkedin.com/posts/ailivesim_ai-sensor-artificialintelligence-activity-7247130900491030528-OoMf?utm_source=share&utm_medium=member_desktop&rcm=ACoAADGIytIBE6sZGG13wmApHwQaCFrzI5jFDXs',
  },
  {
    imageSrc: SecondLinkedInPostImage,
    postUrl:
      'https://www.linkedin.com/posts/ailivesim_syntheticdata-simulation-multisensor-activity-7336348588479766528-jC5-?utm_source=share&utm_medium=member_desktop&rcm=ACoAADGIytIBE6sZGG13wmApHwQaCFrzI5jFDXs',
  },
  {
    imageSrc: ThirdLinkedInPostImage,
    postUrl:
      'https://www.linkedin.com/posts/ailivesim_ailivesim-simulation-autonomoussystems-activity-7312459690938982400-YETb?utm_source=share&utm_medium=member_desktop&rcm=ACoAADGIytIBE6sZGG13wmApHwQaCFrzI5jFDXs',
  },
  {
    imageSrc: ForthLinkedInPostImage,
    postUrl:
      'https://www.linkedin.com/posts/ailivesim_maritimeai-syntheticdata-simulation-activity-7350758541260972034-SykI?utm_source=share&utm_medium=member_desktop&rcm=ACoAADGIytIBE6sZGG13wmApHwQaCFrzI5jFDXs',
  },
  {
    imageSrc: FifthLinkedInPostImage,
    postUrl:
      'https://www.linkedin.com/posts/ailivesim_syntheticdata-simulation-aitraining-activity-7355832269334351872-ll5_?utm_source=share&utm_medium=member_desktop&rcm=ACoAADGIytIBE6sZGG13wmApHwQaCFrzI5jFDXs',
  },
  {
    imageSrc: SixthLinkedInPostImage,
    postUrl:
      'https://www.linkedin.com/posts/ailivesim_defea2025-defenseinnovation-syntheticdata-activity-7325051388118347776-0R9U?utm_source=share&utm_medium=member_desktop&rcm=ACoAAAGXFh4B1x_WE_Thj2lD5IV9coxh5mwE44E',
  },
  {
    imageSrc: ThirdCardImage,
    postUrl: 'https://www.linkedin.com/feed/update/urn:li:activity:7346772262403956740/',
  },
];
